import React from 'react';
import style from './CardSellerPropertiesClosed.module.css';

const CardSellerPropertiesClosed = ({ property }) => {
  // Una operación externa real tiene campos exclusivos del modelo OperacionExterna
  // (inmobiliariaExterna, tipoPropiedad, titulo) y NO tiene campos de Property (title, propertyType, sellerId).
  // No alcanza con solo buyingTip porque propiedades normales también pueden tener buyingTip=true.
  const isOperacionExterna = property?.cerrado?.buyingTip === true && !property?.propertyType;

  // Función para eliminar puntos y convertir a número
  const parsePrice = (price) => {
    if (typeof price === 'string') {
      return parseFloat(price.replace(/\./g, '')) || 0;
    }
    return price || 0;
  };

  // Formatea un número como moneda con puntos
  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const closedPrice = parsePrice(property?.cerrado?.precioCierre);

  if (isOperacionExterna) {
    return (
      <div className={`${style.card} ${style.cardExterna}`}>
        <div className={style.externaBadgeContainer}>
          <span className={style.externaBadge}>Punta Compradora</span>
        </div>
        <div className={style.cardContent}>
          <h5 className={style.cardTitle}>{property.titulo || property.direccion}</h5>
          <p className={style.externaAddress}>{property.direccion}</p>
          {property.tipoPropiedad && (
            <p className={style.externaDetail}>{property.tipoPropiedad} — {property.localidad}{property.provincia ? `, ${property.provincia}` : ''}</p>
          )}
          {property.inmobiliariaExterna && (
            <p className={style.externaDetail}>Inmobiliaria: {property.inmobiliariaExterna}</p>
          )}
          <h5 className={style.cardTitle}>
            Cerrado: {property?.cerrado?.currencyCierre} {formatPrice(closedPrice)}
          </h5>
          {property?.cerrado?.fecha && (
            <p className={style.externaDetail}>Fecha: {new Date(property.cerrado.fecha).toLocaleDateString('es-AR')}</p>
          )}
          {property?.cerrado?.totalComission && (
            <p className={style.externaComision}>Comisión total: {property.cerrado.currencyCierre} {formatPrice(parsePrice(property.cerrado.totalComission))}</p>
          )}
          {property.descripcion && <p className={style.cardText}>{property.descripcion}</p>}
        </div>
      </div>
    );
  }

  // Propiedad cerrada normal
  const publishedPrice = parsePrice(property?.price);

  let percentageChange = 0;
  if (publishedPrice > 0) {
    percentageChange = ((closedPrice - publishedPrice) / publishedPrice) * 100;
  }

  const isPositive = percentageChange >= 0;
  const arrowStyle = isPositive ? style.greenArrow : style.redArrow;

  return (
    <div className={style.card}>
      <div className={style.imageContainer}>
        {property?.photo?.length > 0 && (
          <img src={property.photo[0]} className={style.image} alt={property.title} />
        )}
      </div>
      <div className={style.cardContent}>
        <h5 className={style.cardTitle}>{property.title}</h5>
        <p>{property.id}</p>
        <h5 className={style.cardTitle}>
          Publicado: $ {property.currency} {formatPrice(publishedPrice)} / Cerrado: $ {property?.cerrado?.currencyCierre} {formatPrice(closedPrice)}
        </h5>
        <p className={style.percentageChange}>
          Cambio: 
          <span className={arrowStyle}>
            {isPositive ? '▲' : '▼'} {Math.abs(percentageChange).toFixed(2)}%
          </span>
        </p>
        <p className={style.cardText}>{property.description}</p>
        <div className={style.buttonContainer}></div>
      </div>
    </div>
  );
};

export default CardSellerPropertiesClosed;
